import React from "react";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import BreadCrumb from "../../common/BreadCrumb";
import SwitcherLayout from "./SwitcherLayout";
import { Helmet } from "react-helmet";

const linkList = window.location.pathname
  .split("/")
  .filter((item) => (item !== "" ? item : null));

const Resources = (props) => {
  return (
    <SidebarLayout {...props}>
      {/* {linkList.length > 1 ? <BreadCrumb linkList={linkList} /> : <></>} */}
      {/* <BreadCrumb linkList={linkList} /> */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Resources | Rose Health</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <div className="container-fluid mt-5">
        <SwitcherLayout />
      </div>
    </SidebarLayout>
  );
};

export default Resources;
